
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item/chain",
      function () {
        return require("private-next-pages/item/chain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item/chain"])
      });
    }
  